/**
 * Reusable persona avatar component with proper image positioning
 */

import type { Persona } from "../../types/persona";

type AvatarSize = "sm" | "md" | "lg";

interface PersonaAvatarProps {
  persona: Persona;
  size?: AvatarSize;
  className?: string;
}

const sizeClasses: Record<AvatarSize, string> = {
  sm: "w-8 h-8",
  md: "w-12 h-12",
  lg: "w-20 h-20",
};

export function PersonaAvatar({ persona, size = "md", className = "" }: PersonaAvatarProps) {
  return (
    <div
      className={`rounded-full bg-white bg-cover bg-no-repeat ${sizeClasses[size]} ${className}`}
      style={{
        backgroundImage: `url(/images/${persona.image})`,
        backgroundPosition: persona.imagePosition ?? "center",
        backgroundSize: "150%",
      }}
      role="img"
      aria-label={persona.name}
    />
  );
}
